export const FILESERVE_STATUS = {
	UPLOADING: 1,
	DOWNLOADING: 2,
	SUCCESS: 3,
	ERROR: 4,
}

